export default "__VITE_ASSET__b66948cd__"